import * as types from '../../../lib/actionTypes.es6';

export var getOrgProductTemplatesRequest = function(organizationGuid) {
  return { type: types.GET_ORG_PRODUCT_TEMPLATES_REQUEST, payload: organizationGuid };
};
export var getOrgProductTemplatesSuccess = function(payload) {
  return { type: types.GET_ORG_PRODUCT_TEMPLATES_SUCCESS, payload: payload };
};
export var getOrgProductTemplatesFailure = function(error) {
  return { type: types.GET_ORG_PRODUCT_TEMPLATES_FAILURE, payload: error };
};

export var createOrgProductTemplateRequest = function(payload) {
  return { type: types.CREATE_ORG_PRODUCT_TEMPLATE_REQUEST, payload: payload };
};
export var createOrgProductTemplateSuccess = function(payload) {
  return { type: types.CREATE_ORG_PRODUCT_TEMPLATE_SUCCESS, payload: payload };
};
export var createOrgProductTemplateFailure = function(error) {
  return { type: types.CREATE_ORG_PRODUCT_TEMPLATE_FAILURE, payload: error };
};
export var resetCreateOrgProductTemplateSuccess = function() {
  return { type: types.RESET_CREATE_ORG_PRODUCT_TEMPLATE_SUCCESS };
};
export var resetCreateOrgProductTemplateError = function() {
  return { type: types.RESET_CREATE_ORG_PRODUCT_TEMPLATE_ERROR };
};

export var updateOrgProductTemplateRequest = function(payload) {
  return { type: types.UPDATE_ORG_PRODUCT_TEMPLATE_REQUEST, payload: payload };
};
export var updateOrgProductTemplateSuccess = function(payload) {
  return { type: types.UPDATE_ORG_PRODUCT_TEMPLATE_SUCCESS, payload: payload };
};
export var updateOrgProductTemplateFailure = function(error) {
  return { type: types.UPDATE_ORG_PRODUCT_TEMPLATE_FAILURE, payload: error };
};
export var resetUpdateOrgProductTemplateSuccess = function() {
  return { type: types.RESET_UPDATE_ORG_PRODUCT_TEMPLATE_SUCCESS };
};
export var resetUpdateOrgProductTemplateError = function() {
  return { type: types.RESET_UPDATE_ORG_PRODUCT_TEMPLATE_ERROR };
};

export var deleteOrgProductTemplateRequest = function(payload) {
  return { type: types.DELETE_ORG_PRODUCT_TEMPLATE_REQUEST, payload: payload };
};
export var deleteOrgProductTemplateSuccess = function(payload) {
  return { type: types.DELETE_ORG_PRODUCT_TEMPLATE_SUCCESS, payload: payload };
};
export var deleteOrgProductTemplateFailure = function(error) {
  return { type: types.DELETE_ORG_PRODUCT_TEMPLATE_FAILURE, payload: error };
};
export var resetDeleteOrgProductTemplateSuccess = function() {
  return { type: types.RESET_DELETE_ORG_PRODUCT_TEMPLATE_SUCCESS };
};
export var resetDeleteOrgProductTemplateError = function() {
  return { type: types.RESET_DELETE_ORG_PRODUCT_TEMPLATE_ERROR };
};
